export default __webpack_public_path__ + "static/media/c2.0042b39b.jpg";